<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { schema, doctorNames, chatData, chatMessagesData } from "./data";
import Heading from "../../layouts/heading";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import api from "../../../api";

export default {
  page: {
    title: "Documents",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Heading,
  },
  data() {
    return {
      documents: [],
      rerender: true,
      selectedDocuments: [],
      value: null,
      currentTopic: null,
      currentTopicData: {},
      currentTopicId: null,
      currentTopicActiveStatus: true,
      totalTopics: 0,
      activeTopics: 0,
      enabled5: false,
      editorData: "Hello World",
      chatData: chatData,
      schema: schema,
      formData: {},
      chatMessagesData: chatMessagesData,
      doctorNames: doctorNames,
      topics: null,
      page: {
        title: "Documents",
        lastUpdated: "31 Dec 2020 15:00",
        addNewBtn: true,
        addNewModalTitle: "Upload File",
        formData: {},
        schema: {
          name: {
            type: "file",
            label: "",
            placeholder: "Click Save to upload and return to the main page",
            required: false,
            info: false,
            character_count: 0,
          },
        },
        deleteBtn: true,
        activeBtn: false,
        submitBtn: false,
        searchBox: true,
      },
      submitted: false,
      form: {
        message: "",
      },
      topic: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "lastModifiedDate",
      sortDesc: true,
      fields: [
        { key: "check", label: "#", tdClass: "w-0", checkbox: true },
        { key: "title", label: "Uploaded File", sortable: true },
        {
          key: "additionalProp1.fileFormat",
          label: "File Format",
          sortable: false,
        },
        {
          key: "additionalProp1.fileSize",
          label: "File Size",
          sortable: false,
        },
        { key: "creationDate", label: "Date", sortable: false },
        { key: "lastModifiedDate", label: "Last Modified", sortable: true },
        { key: "actions", label: "Copy Link" },
      ],
    };
  },
  methods: {
    getFileURL(row, baseURL) {
      if (!row.item.url) return "";
      const parsedURL = new URL(row.item.url);

      if (baseURL.startsWith("http")) {
        try {
          if (baseURL.endsWith("/")) {
            const fileURL = `${baseURL}docs${parsedURL.pathname}`;
            return fileURL;
          } else {
            return `${baseURL}/docs${parsedURL.pathname}`;
          }
        } catch (err) {
          console.error("Invalid URL format", err);
          return "";
        }
      } else {
        return `https://${baseURL}/docs${parsedURL.pathname}`;
      }
    },
    async copyURL(row) {
      this.$bvToast.toast("Copied to Clipboard!", {
        title: "Copied",
        variant: "primary",
        solid: true,
      });
      const baseURL = this.currentPractice.additionalProp1.url;
      var inp = document.createElement("input");
      document.body.appendChild(inp);
      const parsedURL = new URL(row.item.url);
      if (baseURL.startsWith("https")) {
        if (baseURL.endsWith("/")) {
          const docURL = `${baseURL}docs${parsedURL.pathname}`;

          inp.value = docURL;
        } else {
          inp.value = `${baseURL}/docs${parsedURL.pathname}`;
        }
      } else {
        inp.value = `https://${baseURL}/docs${parsedURL.pathname}`;
      }
      inp.select();
      document.execCommand("copy");
      document.body.removeChild(inp);
    },
    uncheckedAll() {
      let allChecks = document.getElementsByClassName("docCheck");
      console.log("allChecks", allChecks);
      for (let index = 0; index < allChecks.length; index++) {
        allChecks[index].removeAttribute("checked");
      }
    },
    timer() {
      let timerInterval;
      Swal.fire({
        title: "Uploading File",
        html: "File is uploading",
        timer: 10000,
        timerProgressBar: true,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
        onClose: () => {
          clearInterval(timerInterval);
        },
      }).then((result) => {
        if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.timer
        ) {
          console.log("I was closed by the timer"); // eslint-disable-line
        }
      });
    },
    updateFilter(value) {
      this.filter = value;
    },
    async deleted() {
      var self = this;
      Swal.fire({
        title: `Are you sure you want to delete all selected files?`,
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          for (let doc of self.selectedDocuments) {
            try {
              let url = `/api/pages/${doc.id}`;
              await api.delete(url);
              self.documents.splice(
                self.documents.findIndex(function (i) {
                  return i.id === doc.id;
                }),
                1
              );
              let key = doc.url ? doc.url.split("amazonaws.com/")[1] : "";
              self.deleteFromS3(key);
              Swal.fire(
                "Document Deleted!",
                "Topic Deleted Successfully!",
                "warning"
              );
            } catch (e) {
              console.log(e);
            }
          }
          self.selectedDocuments = [];
          let allChecks = document.getElementsByClassName("docCheck");
          for (let index = 0; index < allChecks.length; index++) {
            allChecks[index].removeAttribute("checked");
          }
        }
      });
    },
    async deleteFromS3(key) {
      try {
        const response = await api.delete(`/api/file/delete`, {
          data: { key: key },
        });
        console.log("File deleted successfully:", response.data);
        return response.data;
      } catch (error) {
        console.error("Error deleting file:", error);
        throw error;
      }
    },
    async uploadToS3(type, buffer, title) {
      // Ensure the buffer is provided for upload
      if (!buffer) {
        console.error("No file buffer provided for upload");
        return;
      }

      let file = new Blob([buffer], { type: type }); // Create a Blob if buffer is raw binary

      // Create FormData object and append the file
      let formData = new FormData();
      formData.append("file", file, title);
      formData.append(
        "dynamo",
        JSON.stringify(this.currentPractice.additionalProp1.dynamo)
      );

      try {
        // Send the request to your LoopBack server using POST method
        const response = await api.post("/api/file", formData);

        // Wait for the server to process the file and respond
        const result = response.data;

        if (response.status === 200) {
          console.log("File uploaded successfully:", result);
          return result;
        } else {
          throw new Error(result.message || "Failed to upload file");
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    },
    sleep(seconds) {
      return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
    },
    async create(vals) {
      if (vals) {
        if (vals.fileSelected.length == 1) {
          let val = vals.fileSelected[0];
          let title = this.page.fileName ? this.page.fileName : val.name;
          let exists = this.documents.find((x) => x.title == title);
          if (exists) {
            console.log("exists");
            Swal.fire(
              "Already Exists!",
              "File already exists in storage, please upload with different name.",
              "warning"
            );
          } else {
            this.timer();
            var buffer = await val.arrayBuffer();
            var result = await this.uploadToS3(val.type, buffer, title);
            let body = {
              uuid: uuidv4(),
              url: result.data,
              active: this.currentTopicActiveStatus,
              title: title,
              picture: "",
              excerpt: "Text here",
              description: "Description here",
              deleted: false,
              creationDate: new Date().toISOString(),
              lastModifiedDate: new Date().toISOString(),
              categoryId: this.$route.params.categoryId,
              cmsId: this.currentCms.id,
              additionalProp1: {
                fileFormat: val.type,
                fileSize: val.size,
                categoryName: this.$route.params.categoryName,
                dynamoId: this.currentPractice.additionalProp1.dynamo,
              },
            };
            try {
              let url = `/api/categories/${this.$route.params.categoryId}/pages`;
              const { data } = await api.post(url, body);
              this.documents.push(data);
              Swal.fire(
                "File Uploaded!",
                "File Uploaded Successfully!",
                "success"
              );
            } catch (e) {
              console.log(e);
            }
          }
        } else if (vals.fileSelected.length > 1) {
          this.timer();
          let val = vals.fileSelected;
          for (let item of val) {
            let title = item.name;
            let exists = this.documents.find((x) => x.title == title);
            let count = 1;
            do {
              if (exists) {
                title = `(${count})${title}`;
              }
              exists = this.documents.find((x) => x.title == title);
              count++;
            } while (exists);
            let buffer = await item.arrayBuffer();
            let result = await this.uploadToS3(item.type, buffer, title);

            let body = {
              uuid: uuidv4(),
              url: result.Location,
              active: this.currentTopicActiveStatus,
              title: title,
              picture: "",
              excerpt: "Text here",
              description: "Description here",
              deleted: false,
              creationDate: new Date().toISOString(),
              lastModifiedDate: new Date().toISOString(),
              categoryId: this.$route.params.categoryId,
              cmsId: this.currentCms.id,
              additionalProp1: {
                fileFormat: item.type,
                fileSize: item.size,
                categoryName: this.$route.params.categoryName,
                dynamoId: this.currentPractice.additionalProp1.dynamo,
              },
            };
            try {
              let url = `/api/categories/${this.$route.params.categoryId}/pages`;
              let { data } = await api.post(url, body);
              this.documents.push(data);
              await this.sleep(5);
            } catch (e) {
              console.log(e);
            }
          }
          Swal.fire("File Uploaded!", "File Uploaded Successfully!", "success");
        }
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    activateToggle() {
      this.currentTopicActiveStatus = !this.currentTopicActiveStatus;
    },
    async getPages() {
      try {
        let url = `/api/categories/${this.$route.params.categoryId}/pages`;
        const { data } = await api.get(url);
        this.documents = data;
      } catch (e) {
        console.log(e);
      }
    },
    selected(val) {
      if (this.selectedDocuments.find((element) => element.id == val.item.id)) {
        this.selectedDocuments.pop(val.item);
      } else {
        this.selectedDocuments.push(val.item);
      }
    },
    numberWithCommas(x) {
      let val = (x / 1000).toFixed(0);
      return val.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
    formatDate(date) {
      if (date !== undefined && date !== "") {
        var myDate = new Date(date);
        var month = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ][myDate.getMonth()];
        var str = myDate.getDate() + "-" + month + "-" + myDate.getFullYear();
        return str;
      }
      return "";
    },
  },
  computed: {
    rows() {
      return this.documents.length;
    },
  },
  watch: {
    currentPage: {
      handler() {
        this.rerender = false;
        this.selectedDocuments = [];
        this.$nextTick(() => {
          this.rerender = true;
        });
      },
    },
  },
  mounted() {
    this.getPages();
  },
};
</script>

<template>
  <Layout>
    <Heading
      :page="page"
      @created="create"
      @filter="updateFilter"
      @deleted="deleted"
    ></Heading>

    <div class="row">
      <div class="col-12">
        <div class="mt-3">
          <div class="d-flex"></div>
          <!-- Table -->
          <div id="user-table" class="table-responsive mb-0" v-if="rerender">
            <b-table
              :items="documents"
              :fields="fields"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
              tbody-tr-class="table-light font-size-16 border-bottom-light"
            >
              <template
                v-slot:cell(check)="row"
                tbody-tr-td-class="font-size-12"
              >
                <div class="badge font-size-16">
                  <input
                    class="docCheck"
                    type="checkbox"
                    v-on:click="selected(row)"
                  />
                </div>
              </template>
              <template v-slot:cell(title)="row">
                <a
                  :href="getFileURL(row, currentPractice.additionalProp1.url)"
                  target="_blank"
                  >{{ row.value }}</a
                >
              </template>
              <template
                v-slot:cell(additionalProp1.fileFormat)="row"
                tbody-tr-td-class="font-size-12"
                >{{
                  row.item.additionalProp1.fileFormat.split("/")[0] != "image"
                    ? "document"
                    : row.item.additionalProp1.fileFormat
                }}
              </template>

              <template v-slot:cell(isAdmin)="row">
                <div class="badge font-size-16">
                  <i
                    :class="
                      row.value
                        ? 'ri-checkbox-circle-fill text-primary'
                        : 'ri-close-circle-fill text-danger'
                    "
                  ></i>
                </div>
              </template>
              <template v-slot:cell(practices)="row">
                <div v-for="practice in practices" :key="practice.id">
                  <div v-if="row.item.isAdmin">
                    <div>
                      {{ practice.name }}
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="practice.userId == row.item.id">
                      {{ practice.name }}
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:cell(additionalProp1.fileSize)="row">
                <div>{{ numberWithCommas(row.value) }} KB</div>
              </template>
              <template v-slot:cell(creationDate)="row">
                <div>
                  {{ formatDate(row.value) }}
                </div>
              </template>
              <template v-slot:cell(lastModifiedDate)="row">
                <div>
                  {{ formatDate(row.value) }}
                </div>
              </template>
              <template v-slot:cell(actions)="row">
                <button
                  v-b-tooltip.hover
                  title="Copy Link"
                  class="btn p-0"
                  @click="copyURL(row)"
                >
                  <i class="ri-file-copy-line"></i>
                </button>
              </template>
            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.border-right-dark {
  border-right: 1px solid #dadce3;
}
</style>
